import { TAxiosResponse } from '@@types/base';
import apis from '@apis/index';
import queryKeys from '@constants/query-keys';
import RECOMMEND_RESTAURANTS from '@constants/sample/recommend-restaurants';
import RESTAURANTS_SAMPLE from '@constants/sample/restaurants';
import usePagingQuery from '@hooks/usePagingQuery';
import { useQuery } from '@tanstack/react-query';
import { IYogiyoMenu } from 'interfaces/menu';
import { IDiscountStore, IYogiyoStore } from 'interfaces/store';
import { useRouter } from 'next/router';

export const fetchStores = (
  categoryKey: string,
  lang: string,
  position: { lat?: string; lng?: string },
  type: 'category' | 'search',
) => {
  const { NODE_ENV } = process.env;
  const isProduction = NODE_ENV === 'production';
  const router = useRouter();
  console.log('fetch => ', position.lat, position.lng);
  const getApis = (params: Record<string, any>) => {
    switch (type) {
      case 'category':
        return apis.store.fetchStores({
          ...params,
          ...position,
          category: categoryKey,
        });
      default:
        return apis.store.searchRestaurants({
          ...params,
          ...position,
          search: categoryKey,
        });
    }
  };

  return usePagingQuery<IYogiyoStore>({
    queryKey: [
      ...queryKeys.STORE.ALL,
      categoryKey,
      lang,
      position.lat,
      position.lng,
      type,
    ],
    queryFn: ({ pageParam }) => getApis(pageParam),
    options: {
      onError: () => {
        router.replace('/');
      },
    },
    // options: {
    //   enabled: isProduction,
    //   initialData: isProduction
    //     ? undefined
    //     : { pages: [RESTAURANTS_SAMPLE], pageParams: [] },
    // },
  });
};

export const fetchMenus = (
  id: string,
  lang: string,
  lat: string,
  lng: string,
) => {
  const router = useRouter();
  return useQuery<TAxiosResponse<IYogiyoMenu[]>>(
    [...queryKeys.MENU.ALL, lang, id, lat, lng],
    () => apis.store.fetchMenus(id, { lat, lng }),
    {
      enabled: id !== '',
      onError: () => {
        router.replace('/');
      },
    },
  );
};

export const fetchRecentOrderedStores = () => {
  const { data } = useQuery(
    [...queryKeys.STORE.RECENT],
    apis.order.fetchRecentOrderedStores,
  );

  return data;
};

export const fetchRecommendedStores = (
  lang: string,
  lat: string | undefined,
  lng: string | undefined,
) => {
  const { NODE_ENV } = process.env;
  const isProd = NODE_ENV === 'production';
  const { data } = useQuery(
    [...queryKeys.STORE.RECOMMENDED, lang, lat, lng],
    () => apis.store.fetchRecommendedStores(lat, lng),
    {
      enabled: !!lat && !!lng,
      // initialData: isProd
      //   ? undefined
      //   : (RECOMMEND_RESTAURANTS as IDiscountStore[]),
    },
  );

  return data;
};

export const fetchAverageRating = (id: string) =>
  useQuery([...queryKeys.STORE.RATINGS, id], () =>
    apis.store.fetchAverageRating(id),
  );

export const fetchReviews = ({ id, page }: { id: string; page: string }) =>
  useQuery([...queryKeys.STORE.REVIEWS, id, page], () =>
    apis.store.fetchReviews({ id, page }),
  );

export const useFetchDetailStore = ({
  storeId,
  lat,
  lng,
}: {
  storeId: string;
  lat: string;
  lng: string;
}) =>
  useQuery([...queryKeys.STORE.DETAILS, storeId, { lat, lng }], () =>
    apis.store.fetchDetailStore(storeId, { lat, lng }),
  );
